<template>
	<div class="box" v-if="popState" @click="popClose">
		<div class="popBox" @click.stop="1">
			<div class="title">{{title}}</div>
			<slot></slot>
				<input class="inpt" v-model="nameVal" :placeholder="nameplaceholder" v-if="nameState" style="display: block;margin: 0 auto;margin-bottom: 10px;"/>
				<input class="inpt" v-model="inputVal" :placeholder="placeholder" v-if="inputState"/>
			<div class="btn" @click="popConfirm">{{btnTxt}}</div>
		</div>
	</div>
</template>

<script>
	export default{
		props:{
			title:{
				type:String,
				default:'添加门卡'
			},
			btnTxt:{
				type:String,
				default:'确认'
			},
			popState:{
				type:Boolean,
				default:false
			},
			placeholder:{
				type:String,
				default:'请输入用户密码'
			},
			inputState:{
				type:Boolean,
				default:true
			},
			nameState:{
				type:Boolean,
				default:false
			},
			nameplaceholder:{
				type:String,
				default:'请输入用户名'
			}
		},
		data(){
			return {
				inputVal:'',
				nameVal:''
			}
		},
		methods:{
			popConfirm(){
				this.$emit('popConfirm',[this.inputVal,this.nameVal])
			},
			popClose(){
				this.$emit('popClose')
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.6);
		position: fixed;
		top: 0;
		left: 0;
	}
	.popBox{
		background-color: #fff;
		width: 80%;
		margin: auto;
		margin-top: 225px;
		border-radius: 10px;
		padding: 20px 0;
	}
	.title{
		font-size: 20px;
		display: flex;
		justify-content: center;
		margin-bottom: 20px;
	}
	.inpt{
		width: 150px;
		border-radius: 15px;
		text-align: center;
		padding: 4px 0;
	}
	.btn{
		width: 75px;
		height: 40px;
		background-color: #1ABC9C;
		color: #fff;
		line-height: 40px;
		text-align: center;
		border-radius: 10px;
		margin: 0 auto;
		margin-top: 20px;
	}
</style>
